import { render, staticRenderFns } from "./SlotPage.vue?vue&type=template&id=27adf82e&scoped=true"
import script from "./SlotPage.vue?vue&type=script&lang=js"
export * from "./SlotPage.vue?vue&type=script&lang=js"
import style0 from "./SlotPage.vue?vue&type=style&index=0&id=27adf82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27adf82e",
  null
  
)

export default component.exports